import WorldScenario from './WorldScenario'

export default WorldScenario
